define("shared/components/shared/button/boost", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "later/utils/constants/segment-events", "@ember/template-factory"], function (_exports, _component, _debug, _object, _service, _utils, _component2, _segmentEvents, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"later/utils/constants/segment-events",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::Button
    @additional={{@additional}}
    @onClick={{this.triggerBoostPost}}
    @variant="default"
    class={{concat-classes (if @class @class)}}
  >
    <EmberTooltip @delay={{100}} @popperContainer="body" @side="top">
      {{t "shared_phrases.boost_post_tooltip"}}
    </EmberTooltip>
    {{svg-jar "boost" class="o--icon"}}
    {{#unless @hideButtonText}}
      <span class="u--m__lr__xs">{{t (if @buttonText @buttonText "shared_phrases.boost_post")}}</span>
    {{/unless}}
    {{#unless @hideExitIcon}}
      {{svg-jar "exit" class="o--icon"}}
    {{/unless}}
  </Shared::Ui::Button>
  */
  {
    "id": "de+GVWk7",
    "block": "[[[8,[39,0],[[16,0,[28,[37,1],[[52,[30,1],[30,1]]],null]]],[[\"@additional\",\"@onClick\",\"@variant\"],[[30,2],[30,0,[\"triggerBoostPost\"]],\"default\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,3],null,[[\"@delay\",\"@popperContainer\",\"@side\"],[100,\"body\",\"top\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,4],[\"shared_phrases.boost_post_tooltip\"],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[1,[28,[35,5],[\"boost\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n\"],[41,[51,[30,3]],[[[1,\"    \"],[10,1],[14,0,\"u--m__lr__xs\"],[12],[1,[28,[35,4],[[52,[30,4],[30,4],\"shared_phrases.boost_post\"]],null]],[13],[1,\"\\n\"]],[]],null],[41,[51,[30,5]],[[[1,\"    \"],[1,[28,[35,5],[\"exit\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n\"]],[]],null]],[]]]]]],[\"@class\",\"@additional\",\"@hideButtonText\",\"@buttonText\",\"@hideExitIcon\"],false,[\"shared/ui/button\",\"concat-classes\",\"if\",\"ember-tooltip\",\"t\",\"svg-jar\",\"unless\"]]",
    "moduleName": "shared/components/shared/button/boost.hbs",
    "isStrictMode": false
  });
  let BoostComponent = _exports.default = (_class = class BoostComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "segment", _descriptor, this);
      (false && !((0, _utils.isPresent)(args.post)) && (0, _debug.assert)('Must pass a GramModel object', (0, _utils.isPresent)(args.post)));
    }
    get mediaId() {
      return this.args.post.mediaId;
    }
    get pageId() {
      return this.args.post.get('socialProfile').get('facebookPageId');
    }
    get redirectUrl() {
      return `https://business.facebook.com/latest/boost_instagram_media_creation/?asset_id=${this.pageId}&target_id=${this.mediaId}`;
    }
    triggerBoostPost(event) {
      event.stopPropagation();
      this.segment.track(_segmentEvents.SegmentEventTypes.ClickedBoostPostCta, {
        area: this.args.location || 'unknown',
        high_performing_post: this.args.post.isHighPerformingPost
      });
      window.open(this.redirectUrl, '_blank');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "triggerBoostPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "triggerBoostPost"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BoostComponent);
});